import {
    ATTRIBUTE_GET_FAILURE,
    ATTRIBUTE_GET_REQUEST,
    ATTRIBUTE_GET_SUCCESS,
} from "../actions/actionTypes";

const initialState = {
    attributes: [],
    loading: false,
    error: null,
};

const attributeReducer = (state = initialState, action) => {
    switch (action.type) {
        case ATTRIBUTE_GET_REQUEST:
            return { ...state, loading: true, error: null };
        case ATTRIBUTE_GET_SUCCESS:
            return { ...state, loading: false, attributes: action.payload };
        case ATTRIBUTE_GET_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default attributeReducer;
